import { useContext, useEffect, useRef } from 'react'
import { useParams } from 'react-router-dom'

import Error404PageWithOffers from 'components/Pages/Error404PageWithOffers/Error404PageWithOffers'
import Error500Page from 'components/Pages/Error500Page'
import LoadingIndicator from 'components/Common/Loading/LoadingIndicator'
import CruiseContent from './content/CruiseContent'
import { fireEcommerceGTMEvent } from 'api/googleTagManager'
import { cruiseOfferClicked } from 'analytics/eventDefinitions'
import RedirectWithStatus from 'components/Common/RedirectWithStatus'
import offerPageURL from 'lib/offer/offerPageURL'
import { usePageActivityTracking } from 'analytics/snowplow/helpers/useActivityTracking'
import useOffer from 'hooks/Offers/useOffer'
import GeoContext from 'contexts/geoContext'
import { isUuidV4 } from 'lib/string/uuidV4Utils'

function CruiseOfferPage() {
  const { offerId: routeOfferId = '', offerSlug } = useParams<{ offerId: string, offerSlug: string }>()
  const { currentRegionCode } = useContext(GeoContext)

  // The ID prefix is required so that useOffer knows which API to call.
  // TODO: Remove ID prefix once we have support for cruise in the public offer - https://aussiecommerce.atlassian.net/browse/CRUZ-2932
  const offerId = `cruise-details:${routeOfferId}`

  const [cruiseOffer, fetching, offerError] = useOffer<App.CruiseOffer>(offerId)
  const dataLoaded = useRef(false)

  useEffect(() => {
    if (cruiseOffer) {
      // we use dataLoaded ref to prevent multiple analytics pushes
      fireEcommerceGTMEvent(cruiseOfferClicked(cruiseOffer))
      dataLoaded.current = true
    }
  }, [cruiseOffer])

  usePageActivityTracking()

  if (offerError) {
    if (offerError?.status == 404 || !isUuidV4(routeOfferId)) {
      return <Error404PageWithOffers />
    } else {
      return <Error500Page error={offerError} />
    }
  }

  if (fetching || !cruiseOffer) {
    return <LoadingIndicator />
  }

  if (offerSlug) {
    return <RedirectWithStatus code={301} to={`/${currentRegionCode.toLowerCase()}${offerPageURL(cruiseOffer)}`} />
  }

  return <CruiseContent offer={cruiseOffer} />
}

export default CruiseOfferPage
